export default __webpack_public_path__ + "static/media/fmWebApp1.86ff82b2.jpg";